import { render, staticRenderFns } from "./BillingDetails.vue?vue&type=template&id=c5da447c&scoped=true"
import script from "./BillingDetails.vue?vue&type=script&lang=js"
export * from "./BillingDetails.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./BillingDetails.vue?vue&type=style&index=0&id=c5da447c&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "c5da447c",
  "985b6f50"
  
)

export default component.exports